import { DataSoldProducts, FetchSoldProductsSearchProps, ListSoldProducts } from 'lib/models/listSoldProducts';
import { useCallback, useEffect, useState } from 'react';

function useListSoldProducts(searchProps?: FetchSoldProductsSearchProps) {
	const [loading, setLoading] = useState<boolean>(true);
	const [soldProducts, setSoldProducts] = useState<DataSoldProducts>({} as DataSoldProducts);

	const refetch = useCallback(async (props?: FetchSoldProductsSearchProps) => {
		setLoading(true);
		const response = await ListSoldProducts(props || searchProps);
		setSoldProducts(response);
		setLoading(false);
	}, [searchProps]);

	useEffect(() => {
		refetch();
	}, [refetch]);

	return { loading, soldProducts, refetch, setLoading };
}

export default useListSoldProducts;
